<script>
import { required } from "vuelidate/lib/validators";

export default {
    name: "BpReportParameters",
    data() {
        return {
            form: {
                status: "",
                tier: "Tier1",
            },
            submitted: false,
            isSummary: false,
        };
    },
    validations: {
        form: {
            status: { required },
            tier: { required },
        },
    },
    methods: {
        hideModal() {
            this.$bvModal.hide("bp-report-parameters-modal");
        },
        resetForm(status, isSummary = false) {
            this.form.status = status || 'All';
            this.form.tier = "All";
            this.form.summary = isSummary;
            this.isSummary = isSummary;
            this.submitted = false;
            this.$v.$reset();
        },
        onSubmit() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            let data = JSON.parse(JSON.stringify(this.form));
            this.$emit("submit", data);
        },
    },
}
</script>
<template>
    <b-modal id="bp-report-parameters-modal" title="Report Parameters" size="md" title-class="font-18" hide-footer
        no-close-on-backdrop no-close-on-esc>
        <form @submit.prevent="onSubmit">
            <div class="mb-3">
                <label for="status">Status</label>
                <select autocomplete="off" v-model="form.status" class="form-select" :class="{
                    'is-invalid':
                        submitted && $v.form.status.$error,
                }">
                    <option value="" disabled>Select Status</option>
                    <option value="All">All</option>
                    <option value="DRAFT">Draft</option>
                    <option value="POSTED">Posted</option>
                    <option value="SHORTLISTED">Short Listed</option>
                    <option value="PARKED">Parked</option>
                    <option value="APPROVED">Approved</option>
                    <option value="RETURNED">Returned</option>
                </select>
                <div v-if="submitted && $v.form.status.$error" class="invalid-feedback">
                    <span v-if="!$v.form.status.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3" v-if="!isSummary">
                <label for="tier">Tier</label>
                <select autocomplete="off" id="tier" v-model="form.tier" class="form-select" :class="{
                    'is-invalid':
                        submitted && $v.form.tier.$error,
                }">
                    <option value="All">All</option>
                    <option value="Tier1">Tier 1</option>
                    <option value="Tier2">Tier 2</option>
                </select>
                <div v-if="submitted && $v.form.tier.$error" class="invalid-feedback">
                    <span v-if="!$v.form.tier.required">This value is required.</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    <i class="bx bx-printer"></i> Generate Report
                </button>
                <button type="button" class="btn btn-link" @click="hideModal">
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>